import { createContext } from 'react';

// Carries the live, page-level action context (the SAME useReferralActions object
// the top toolbar uses, plus its gating inputs) from a redesigned page down to the
// per-row RowQuickActions menu rendered inside the shared InboxTable — which is a
// sibling of the page component, not a descendant, so props can't reach it.
//
// The value is a mutable ref object the page refreshes on every render, so menu
// items read the freshest handlers/selection at click time. The Provider is
// mounted in the above-HOC wrapper so it wraps BOTH the page (writer) and the
// table (reader). null means "no redesigned page above" → RowQuickActions no-ops,
// which keeps legacy surfaces untouched.
const ReferralRowActionsContext = createContext(null);

export default ReferralRowActionsContext;
